import {AiOutlineRight} from 'react-icons/ai'

const HeroSection = () => {

    return (

        <section className="herosection" >

            <div className="herosection_center" >
                <a href="#preorder">
                    Pre-order Now!
                </a>
                <a href="#learn_more" >
                    Learn more
                    <AiOutlineRight className='herosection_center_ic' />
                </a>
            </div>

        </section>

    );

}

export default HeroSection;